'use client';

import { createScopeFromContext } from 'bunja/react';
import { Params } from 'next/dist/server/request/params';
import { useParams, usePathname, useRouter } from 'next/navigation';
import React from 'react';

import { Providers } from './providers';

// TODO react -> features 로 이동 필요
// TODO next/navigation -> i18n 으로 변경 방법 찾아야 할듯
export type Router = ReturnType<typeof useRouter>;

export const RouterContext = React.createContext<Router>(null as unknown as Router);
export const RouterScope = createScopeFromContext(RouterContext);

export const PathnameContext = React.createContext<string>('');
export const PathnameScope = createScopeFromContext(PathnameContext);

export const ParamsContext = React.createContext<Params>({});
export const ParamsScope = createScopeFromContext(ParamsContext);

export const RouteProvider = ({ children }: React.PropsWithChildren) => {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();

  return (
    <Providers
      providers={
        <>
          <RouterContext value={router} />
          <PathnameContext value={pathname} />
          <ParamsContext value={params} />
        </>
      }
    >
      {children}
    </Providers>
  );
};
